import React, { Component } from "react";

class NoMatch extends Component {
  render() {
    return (
      <div>
        <p>noMatch</p>
      </div>
    );
  }
}

export default NoMatch;
